import { Box } from '@material-ui/core';
import { Mixpanel } from '../mixpanel';
import { SizeType } from 'common-ts/dist/models/Cart';
import { ProductOnUser } from 'common-ts/dist/models/Product';
import { ClothingType, FitType, UserBodyMeasurements, UserClothTypeSpecificBodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import { inputMeasurementsForm, postClothingMeasurement } from '../redux/MeasurementsRedux';
import { useAppDispatch } from '../reduxhooks';
import OverlayViewRegularSelectSize from './OverlayViewGenerateMeasureMethod2Regular0SelectSize';
import { closeOverlayAndReset } from '../redux/UIOverlayMeasurementMethodSelectionViewRedux';
import { closeOverlayAndReset as closeOverlayAndResetSelection } from '../redux/UIOverlayMeasurementSelectionViewRedux';

// Determines which flow is used based on starting parameters
export interface FlowSelectionData {
  chatUserId: string
  clothingType: ClothingType
  fitType: FitType
  isSignedIn: boolean
  addToCartAfterCreation: boolean
  productDetail: ProductOnUser | undefined
}

// State data for flow
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateData {
  currentScreen: string
  titleNumber: number
  currentUserMeasurement: UserClothTypeSpecificBodyMeasurements
  currentUserBodyMeasurement: UserBodyMeasurements
  isDesktop: boolean
}

// Callback to change state data for flow.
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateCallback {
  delayedDispatch: (currentScreen: 'regularSize' | 'dibuatinAtauBuatSendiri' | 'favoriteOrAlgorithmSize') => void
  setTitleNumber: (titleNumber: number) => void
}

//
// RENDERER
// Master function that is used to select and pass data to the block
// selected using the flow selection data.
// Regular sizing only — the personal-size flows (algorithm, favorite,
// instant size team) have been removed.
//
export function FlowComponentMaster(flowSelectionData: FlowSelectionData,
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {

  let children: JSX.Element[] = [];
  children = FlowComponentRegularSize(flowSelectionData, flowStateData, flowStateCallback);

  // We choose the right block to use with the flow selection data.
  return (
    <Box>
      {
        children
      }
    </Box>
  );
}

function FlowComponentRegularSize(flowSelectionData: FlowSelectionData,
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  const dispatch = useAppDispatch();

  let titleNumber = -1;

  let children: JSX.Element[] = [];

  children.push(
  <Box style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
  <Box style={{
    width: '90%',
    marginBottom: '80px',
  }}>
  <OverlayViewRegularSelectSize
    isMinimized={true}
    useMobileView={true}
    productId={ flowSelectionData?.productDetail?.productId }
    clothingType={flowStateData.currentUserMeasurement.clothingType as ClothingType}
    fitType={flowStateData.currentUserMeasurement.fitType as FitType}
    key2={flowStateData.currentUserMeasurement.clothingType + "-" + flowStateData.currentUserMeasurement.fitType}
    handleSubmit={(value) => {
      Mixpanel.track('regularSelectSizeNext', {
        'selectedSize': value,
      });
      let userMeasurements: UserClothTypeSpecificBodyMeasurements = {
        sizeType: SizeType.regular,
        measurementName: value,
        regularSize: value,
        bodyOrClothingMeasurements: "CLOTHING",
        creationMethod: "online-reguler",
      }
      dispatch(inputMeasurementsForm(userMeasurements));

      dispatch(postClothingMeasurement());

      dispatch(closeOverlayAndReset());
      dispatch(closeOverlayAndResetSelection());
    }}
  />
  </Box>
  </Box>);

  if (flowStateData.titleNumber != titleNumber) {
    flowStateCallback.setTitleNumber(titleNumber);
  }

  return children;
}
